import { Select } from "antd";
import { useProductMapping } from "modules/dashboards/actionables/store";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Placeholder } from "react-bootstrap";
import {
  reportTotalStyle,
  reportTotalStyleFirst,
  reportStyle,
  reportStyleFirst,
  column,
} from "./styleReport";
import { skuReport } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { comboProductMappings } from "../../config";
import { calculateSkus, isDownloadDisabled } from "modules/utilities/utility";

function StockReportTable({
  isLoading,
  stockReportData,
  setSelectedSku,
  warehouses,
}) {
  const [sortData, setSortedData] = useState([]);
  const [sku, setSku] = useState(null);
  const { productsData, fetchProducts } = useProductMapping();
  const { fetchSkuReport } = skuReport();
  const { setToaster } = useToast();

  useEffect(() => {
    setSortedData(stockReportData);
  }, [stockReportData]);
  useEffect(() => {
    fetchProducts();
  }, []);
  const skus = useMemo(() => calculateSkus(productsData, comboProductMappings), [productsData]);
  const handleSku = (event) => {
    if (event) {
      setSelectedSku(event);
      setSku(event);
    } else {
      setSelectedSku("");
    }
  };
  const handleDownload = () => {
    const payload = { skuId: sku, category: "warehouse_skus" };
    fetchSkuReport(payload, setToaster);
  };
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Select
          allowClear
          style={{ width: "30%" }}
          placeholder="Select Skus"
          options={skus}
          onChange={handleSku}
        />
        <Button variant="primary" onClick={handleDownload} disabled={isDownloadDisabled}>
          Download
        </Button>
      </div>
      <div
        className="scrollable-table scrollable-container rounded mt-5"
        style={{ maxHeight: "65vh" }}
      >
        <table className="table table-responsive table-striped table-bordered border border-white table-hover shadow">
          <thead className="table-head">
            <tr className="table-head">
              <th
                className="flex-1 align-top text-center table-head text-black fw-bold"
                style={reportStyleFirst}
              >
                Sku
              </th>
              <th
                className="flex-1 align-top text-center table-head text-black fw-bold"
                style={reportTotalStyleFirst}
              >
                Total
              </th>
              <th
                className="flex-1 align-top text-center table-head text-black fw-bold"
                style={reportTotalStyleFirst}
              >
                Product Id
              </th>
              {warehouses?.map((item, index) => (
                <th
                  key={index}
                  style={column}
                  className="align-top text-center table-head fixed-width border text-black fw-bold border border-collapse"
                >
                  {item?.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading
              ? Array.from({ length: 3 })?.map((_, index) => (
                  <tr>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <td>
                        <Placeholder as="p" animation="glow">
                          <Placeholder xs={12} />
                        </Placeholder>
                      </td>
                    ))}
                  </tr>
                ))
              : sortData?.map((item, index) => {
                  const sum = warehouses?.reduce((acc, warehouse, index) => {
                    return acc + Number(item[warehouses[index]?.value] || 0);
                  }, 0);

                  // Find the SKU name in the comboProductMappings object, if it exists
                  const skuNameFromMapping =
                    item.medicineShortName || item.skuName;

                  return (
                    <tr key={index} className="row-hover">
                      <td
                        className={
                          index === 0
                            ? "text-center text-black fw-bold"
                            : "text-center text-black fw-bold"
                        }
                        style={reportStyle}
                      >
                        {skuNameFromMapping}{" "}
                        {/* Display the mapped SKU name if it exists, otherwise, use the original SKU name */}
                      </td>
                      <td
                        className="text-center text-black fw-bold"
                        style={reportTotalStyle}
                      >
                        {sum}
                      </td>
                      <td
                        className="text-center text-black fw-bold"
                        style={reportTotalStyle}
                      >
                        {item.productId}
                      </td>
                      {warehouses?.map((warehouse, wIndex) => {
                        return (
                          <td
                            key={wIndex}
                            className="p-3 text-break text-black border border-collapse"
                            style={{ minWidth: "10rem", maxHeight: "10rem" }}
                          >
                            {item[warehouses[wIndex]?.value] || "0"}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default StockReportTable;
